const RequiredAsterisk = () => {
  return (
    <sup className="text-red-500 font-semibold">
      *
    </sup>
  );
};

export default RequiredAsterisk;